import axiosInstance from "./axiosInstance";

const lostProductService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/lost-products/create', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('/lost-products/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    fetchSingle: async (id) => {
        try {
            const response = await axiosInstance.get(`/lost-products/get/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    update: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/lost-products/update/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    delete: async (id) => {
        try {
            const response = await axiosInstance.put(`/lost-products/delete/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    fetchByDate: async (payload) => {
        try {
            const response = await axiosInstance.post('/lost-products/date', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default lostProductService;